import { FC } from "react"
import { AclStrategy, IVisibilityAcl } from "@/shared/api/groups"
import { getAclStrategyLabel } from "@/entities/visibility-acl"
import { ACL_STRATEGY_OPTIONS } from "@/entities/visibility-acl"

interface AclTableProps {
    aclList: IVisibilityAcl[]
    isLoading: boolean
    isDeleting: string | null
    onDelete: (aclId: string) => void
}

const getTargetLabel = (acl: IVisibilityAcl): string => {
    if (acl.target_type === "group" && acl.target_group) {
        return acl.target_group.name
    }
    if (acl.target_type === "user" && acl.target_user) {
        return acl.target_user.name || acl.target_user.username || acl.target_id
    }
    return acl.target_id
}

const getTargetTypeLabel = (acl: IVisibilityAcl): string => {
    return acl.target_type === "group" ? "Группа" : "Пользователь"
}

export const AclTable: FC<AclTableProps> = ({
    aclList,
    isLoading,
    isDeleting,
    onDelete,
}) => {
    if (isLoading) {
        return (
            <div className="box">
                <div className="box_header font-medium">Список ACL</div>
                <div className="text-center py-8 text-gray-500">Загрузка...</div>
            </div>
        )
    }

    if (aclList.length === 0) {
        return (
            <div className="box">
                <div className="box_header font-medium">Список ACL</div>
                <div className="text-center py-8 text-gray-500">Нет ACL записей</div>
            </div>
        )
    }

    return (
        <div className="box">
            <div className="box_header font-medium">Список ACL</div>
            <div className="flex flex-col gap-2 mt-4">
                {aclList.map((acl) => (
                    <div
                        key={acl.id}
                        className="border rounded-lg p-3 flex justify-between items-start gap-4"
                    >
                        <div className="flex flex-col gap-1 min-w-0">
                            <div className="text-sm font-medium">
                                {getTargetTypeLabel(acl)}: {getTargetLabel(acl)}
                            </div>
                            {acl.target_type === "group" && (
                                <div className="text-sm text-gray-600">
                                    Стратегия: {getAclStrategyLabel(acl.acl_strategy, ACL_STRATEGY_OPTIONS)}
                                </div>
                            )}
                            {acl.acl_strategy !== AclStrategy.INHERIT_ONLY && (
                                acl.groups === null ? (
                                    <div className="text-sm text-gray-600">Видимые группы: Все группы</div>
                                ) : acl.groups && acl.groups.length > 0 ? (
                                    <div className="text-sm text-gray-600">
                                        Видимые группы: {acl.groups.map((g) => g.name).join(", ")}
                                    </div>
                                ) : (
                                    <div className="text-sm text-gray-600">Видимые группы: Не указаны</div>
                                )
                            )}
                        </div>
                        <button
                            onClick={() => onDelete(acl.id)}
                            disabled={isDeleting === acl.id}
                            className="text-red-600 hover:text-red-800 disabled:opacity-50 px-2 py-1 shrink-0"
                            type="button"
                        >
                            {isDeleting === acl.id ? "Удаление..." : "Удалить"}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    )
}
